import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import {
  ICreateMotorista,
  ICreateMotoristaUpload,
  IEditMotorista
} from './motorista.model';

@Injectable({
  providedIn: 'root'
})
export class MotoristaService {
  constructor(private http: HttpClient) {}

  CreateMotoristaEmpresa(body: object, guid: string): Observable<any> {
    const headers = new HttpHeaders({
      IdempotencyKey: guid
    });
    return this.http.post<any>(
      `${environment.baseURL}MotoristaEmpresa/CreateMotoristaEmpresa`,
      body,
      { headers: headers }
    );
  }

  CreateMotoristaUpload(
    body: ICreateMotoristaUpload,
    guid: string
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      IdempotencyKey: guid
    });

    return this.http.post<any>(
      `${environment.baseURL}MotoristaEmpresa/CreateMotoristaEmpresaByUpload`,
      body,
      { headers: headers, responseType: 'text' as 'json' }
     );
  }

  public EditarMotorista(pkMotorista: number, body: object): Observable<any> {
    const url = `${environment.baseURL}MotoristaEmpresa/UpdateMotoristaEmpresa?id=${pkMotorista}`;

    return this.http.put<any>(url, body);
  }
  public GetMotoristaEmpresa({
    nomeMotoristaEmpresa,
    cpfMotoristaEmpresa,
    idEmpresa,
    pageNumber,
    pageSize,
    paginar = true,
    status = 1
  }: {
    nomeMotoristaEmpresa?: string;
    cpfMotoristaEmpresa?: string;
    idEmpresa?: string | null;
    pageNumber?: number;
    pageSize?: number;
    paginar?: boolean;
    status?: number;
  }): Observable<any> {
    const invalid = ['', undefined, 0, NaN];
    const url = `${environment.baseURL}MotoristaEmpresa/GetMotoristasEmpresa`;
    const params: any = {};

    if (nomeMotoristaEmpresa !== undefined) {
      params.NM_USUA_MTRT = nomeMotoristaEmpresa;
    }
    if (cpfMotoristaEmpresa !== undefined) {
      params.TX_CPF_MTRT = cpfMotoristaEmpresa;
    }
    if (idEmpresa !== undefined) {
      params.FK_EPSA = idEmpresa;
    }
    if (!invalid.includes(pageNumber)) {
      params.PAGE_NUMBER = pageNumber;
    }
    if (!invalid.includes(pageSize)) {
      params.PAGE_SIZE = pageSize;
    }
    if (!paginar) {
      const numeroMaximoRegistros = 2147483647;
      params.PAGE_SIZE = numeroMaximoRegistros;
    }

    params.NU_STTS_ALL = status;

    return this.http.get<any>(url, { params });
  }

  public GetMotoristaById(id?: number): Observable<any> {
    let url = `${environment.baseURL}MotoristaEmpresa/GetMotoristaEmpresaById`;
    if (id !== undefined) {
      url += `?id=${id}`;
    }
    return this.http.get<any>(url);
  }

  patchMotoristaEmpresa(motoristaId: number, status: number): Observable<any> {
    const url = `${environment.baseURL}MotoristaEmpresa/PatchMotoristaEmpresaStatus?id=${motoristaId}`;

    const body = {
      NU_STTS_MTRT: status
    };

    return this.http.patch(url, body);
  }
}
